// GLM5.3, OpenCode Go. Edited with Matthew, Hermes and unslop.
export const resetCopy = {
  title: 'Quick Reset', open: 'Open session', play: 'Play',
  days: 'Practice days', run: 'Current run', best: 'Personal best',
  milestones: 'Milestones', earned: 'Earned', notYet: 'Not yet', daysUnit: 'days',
  loading: 'Finding a free session...',
  unavailable: 'Something went wrong with the audio. You can try again.',
  browse: 'Browse free sessions', retry: 'Try again',
  local: 'This is a local preview. Practice days are saved on this device only. They do not follow you to other devices. Clearing your browser data removes them.',
  legacy: 'Older practice dates are a retained minimum. Your earlier history may include more. Those dates used a 4am day boundary.',
  grace: 'One missed day can be bridged. Only days you practised count toward your run. Two missed days in a row end your current run. Milestones you have earned stay earned.',
  storage: 'Your practice could not be saved. It counts for this visit only. Your earlier data is kept.',
  qualified: 'A practice day was recorded on this device.', choose: 'Choose your reset',
  back: 'Back', minutes: 'min', listening: 'Press play when you are ready to listen.',
  durationNote: 'The length shown is a library estimate. When playback loads, the media length replaces it.',
}
